/*
 * File: ErrorComponent.styles.js
 * Project: lets-talk-web
 *
 * Created by Brendan Michaelsen on February 19, 2022 at 12:20 AM
 * Copyright © 2022 Let's Talk. All rights reserved.
 *
 * Last Modified: April 29, 2024 at 2:20 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';

// Components
import { LocaleLink } from '../LocaleLink';

// Constants
import { mediumBreakpoint, smallBreakpoint } from '../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	height: 100%;
	width: 100%;
`;

export const ContentContainer = styled.div`
	margin: -30px auto 0px;
	text-align: center;
	padding-bottom: 30px;

	h1 {
		margin-bottom: 20px;
	}
	h4 {
		margin: 5px 0 35px;
	}
	@media only screen and (min-width: ${smallBreakpoint}em) {
		margin: 30px auto 0px;
	}
`;

export const MessageContainer = styled.div`
	width: 100%;
	margin: -40px auto 0px;

	@media only screen and (min-width: ${smallBreakpoint}em) {
		margin: 0px auto 0px;
	}
	@media only screen and (min-width: ${mediumBreakpoint}em) {
		max-width: 800px;
	}

	* {
		text-align: center !important;
	}
	a,
	a:visited,
	a:link {
		color: inherit;
	}
`;

export const DescriptionContainer = styled.div`
	width: 100%;
	margin: 0px auto 50px;

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		max-width: 650px;
	}
`;

export const ActionContainer = styled.div`
	text-align: center;
	margin: -30px auto 0px;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;

	button {
		width: 100%;
		font-size: 1.0rem;
		margin-top: 15px;
		padding-left: 50px;
		padding-right: 50px;
	}

	a {
		${({ fullWidth }) => (fullWidth ? css`
			width: 95%;

			@media only screen and (min-width: ${mediumBreakpoint}em) {
				width: 400px;
			}
		` : css`
			margin: 0 10px;
		`)};
	}

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		flex-wrap: nowrap;
	}
`;

export const ButtonLink = styled(LocaleLink)`
	text-decoration: none;
`;

export const LottieContainer = styled.div`
	text-decoration: none;
	width: 100%;
	display: block;
	margin: 0 auto;

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		width: 600px;
	}
`;
